import { styled } from '@mui/material';

export const StyledContainer = styled('div')(() => ({
  maxWidth: 'calc(1280px + 2.5rem)',
  width: '100%',
  padding: '1.25rem',
  marginLeft: 'auto',
  marginRight: 'auto',
}));
